import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=01f40b19&scoped=true&"
var script = {}
import style0 from "./Faq.vue?vue&type=style&index=0&id=01f40b19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f40b19",
  null
  
)

export default component.exports